import Page from 'components/Page';

export default Page;
